import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Checkbox, useTranslation } from '@nextgen-web-framework/all';
import type { AppDispatch, AppState } from '@nextgen-web-framework/core';
import { updateTncAccepted } from '@commerce-subscription-webcomponents/sdk';
import TnCDrawer from '../TnCDrawer/TnCDrawer';
import { TermsAndConditionPropTypes } from './types/propTypes';
import styles from './TermsAndCondition.module.scss';

const TermsAndCondition = ({ onChecked }: TermsAndConditionPropTypes) => {
  const { tncAccepted } = useSelector((state: AppState) => state.commerceSubscription);

  const [tncDrawer, setTncDrawer] = useState<boolean>(false);

  const t = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  const onclick = () => {
    updateTnCAccepted(!tncAccepted);
  };

  const updateTnCAccepted = (val: boolean) => {
    if (onChecked) {
      onChecked(val);
    }
    dispatch(updateTncAccepted(val));
  };

  return (
    <div data-testid="tnc-test-id">
      <div className={styles['tnc-container']}>
        <Checkbox
          data-testid="tnc-checkbox-test-id"
          text={''}
          id="subscription-terms-conditions"
          checked={tncAccepted}
          onClick={onclick}
        />
        <div className={styles['tnc-text']}>
          <label htmlFor="checkbox-subscription-terms-conditions">
            {t('subscription.TermsAndConditions.termsAndConditionTextPart1')}
          </label>
          <span
            role="presentation"
            data-testid="tnc-link-test-id"
            className={styles['tnc-link']}
            onClick={() => setTncDrawer(true)}
          >
            {t('subscription.TermsAndConditions.termsAndConditionTextPart2')}
          </span>
        </div>
      </div>
      <div className={styles['tnc-drawer-container']}>
        {tncDrawer && <TnCDrawer showDrawer={setTncDrawer} onAcceptTnC={updateTnCAccepted} />}
      </div>
    </div>
  );
};

export default TermsAndCondition;
